import appAxios from "../services/axios";

export const getPlayerCharacters = async () => {
  const res = await appAxios.get("/api/playercharacter");
  return res.data;
};

export const getPlayerCharacter = async (playerCharacterId) => {
  const res = await appAxios.get(`/api/playercharacter/${playerCharacterId}`);
  return res.data;
};

export const putActiveCharacter = async (playerCharacterId) => {
  const res = await appAxios.put(
    `/api/user/playercharacter/${playerCharacterId}/active`,
    { playerCharacterId },
  );
  return res.data;
};

export const putActiveCharacterTree = async ({ playerCharacterId, treeId }) => {
  const res = await appAxios.put(
    `/api/user/playercharacter/${playerCharacterId}/activeTree/${treeId}`,
    { playerCharacterId },
  );
  return res.data;
};
